import React from 'react';
import { SectionLabel } from './SectionLabel';
import { MissedCallVisual } from './visuals/MissedCallVisual';
const facts = [{
  stat: 'Rings 4x',
  body: 'Then it goes to voicemail. Most people don’t leave one. They go back to the results page they came from.'
}, {
  stat: 'Next guy',
  body: 'The one below you on Google answers on the second ring. Same neighborhood, same job, your ad money.'
}, {
  stat: 'Paid twice',
  body: 'You paid Yelp for the lead and you paid your crew to be busy. Missing the call means you got neither.'
}];
export function Leak() {
  return <section className="border-b border-[#1a1a1a]" data-id="element-350" data-mp="35bkm09w00jco">
      <div className="mx-auto w-full max-w-6xl px-6 py-20 lg:py-28" data-id="element-351" data-mp="358omwi8ezomn">
        <SectionLabel data-id="element-352" data-mp="3a8b2uzfmniz5">The leak</SectionLabel>

        <div className="mt-8 grid grid-cols-1 items-center gap-12 lg:grid-cols-[1.1fr_0.9fr] lg:gap-16" data-id="element-353" data-mp="1u2i2djcjwhj">
          <div data-id="element-354" data-mp="6kivhxn63i3w">
            <h2 className="text-3xl font-bold leading-tight tracking-tight text-white sm:text-4xl" data-id="element-355" data-mp="6l0ydd4c4uks">
              A missed call isn&rsquo;t a missed call. It&rsquo;s a booked job walking to the next
              guy on Google.
            </h2>
            <p className="mt-6 text-lg leading-relaxed text-neutral-400" data-id="element-356" data-mp="12cnssazobmj3">
              You already paid for that person: ad spend, Yelp fees, years of reviews. The lead
              doesn&rsquo;t disappear when you&rsquo;re under a sink at 2pm. It just goes
              somewhere else.
            </p>
          </div>
          <MissedCallVisual data-id="element-357" data-mp="1l1azexxi0jys" />
        </div>

        <ul className="mt-14 grid grid-cols-1 gap-px overflow-hidden rounded-xl border border-[#1c1c1c] bg-[#1c1c1c] sm:grid-cols-3" data-id="element-358" data-mp="1l09d1xb18b1r">
          {facts.map(f => <li key={f.stat} className="bg-[#0d0d0d] p-7" data-id="element-359" data-mp="1u28tooi4xd46">
              <p className="font-mono text-sm uppercase tracking-[0.15em] text-emerald-500" data-id="element-360" data-mp="1u2sau2zynxh5">
                {f.stat}
              </p>
              <p className="mt-3 text-sm leading-relaxed text-neutral-400" data-id="element-361" data-mp="3vtlw96wmr8x2">{f.body}</p>
            </li>)}
        </ul>
      </div>
    </section>;
}